module.exports = __webpack_public_path__ + "img/healthidv.76dea234.svg";